var React = require('react');

function Arrowdown (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","transform":"translate(6 4)"},[React.createElement("path",{"d":"m.5 9.499 4 4.001 4-4.001","key":0}),React.createElement("path",{"d":"m4.5.5v13","transform":"matrix(-1 0 0 -1 9 14)","key":1})]));
}

Arrowdown.defaultProps = {"height":"21","viewBox":"0 0 21 21","width":"21"};

module.exports = Arrowdown;

Arrowdown.default = Arrowdown;
